export const TABLE_HEADER_ROWS_CONFIGURATION: string[] = [
    'header-row-region',
    'header-row-cp',
    'header-row-hurdles',
    'header-row-initiatives'
];